import React, { useState } from 'react';

import { InputProps } from '@opendoor/bricks/core';

import * as api from '../api';
import { useObservability } from '../../helpers/observability';
import { PARTNERSHIP_BFF_URL } from '../globals';
import Footer from '../shared/Footer';
import Hero from './Hero';
import { IPartnersPageProps } from './PartnersPage';

const BuilderSalesPage: React.FC<IPartnersPageProps> = (props: IPartnersPageProps) => {
  const { trackEvent } = useObservability();
  const [email, setEmail] = useState<string>();
  const [ctaInputLoading, setCtaInputLoading] = useState<boolean>();
  const [isEmailInvalid, setIsEmailInvalid] = useState<boolean>(false);

  const onEmailChange: InputProps['onChange'] = (_event, value) => {
    setEmail(value);
  };

  const handleSubmit = async (event: React.FormEvent<HTMLElement>) => {
    event.preventDefault();
    setCtaInputLoading(true);
    if (!email) {
      return;
    }
    api
      .validatePartnerEmailAddress(email)
      .then((resp) => {
        if (!resp || !resp.validateEmail.isValid) {
          setIsEmailInvalid(true);
          setCtaInputLoading(false);
          // TODO: remove categoryOverride
          // observability is initialized with 'cosmos' as the category for all events
          trackEvent(
            'invalid-email',
            undefined,
            { email },
            { categoryOverride: 'partner-sign-up-flow' },
          );
          return;
        }
        // TODO: remove categoryOverride
        // observability is initialized with 'cosmos' as the category for all events
        trackEvent('valid-email', undefined, undefined, {
          categoryOverride: 'partner-sign-up-flow',
        });
        setEmail(resp.validateEmail.normalizedEmail);
        const redirectParams = new URLSearchParams();
        redirectParams.set('email', email);
        redirectParams.set('partnershipType', props.partnerChannel);
        redirectParams.set('role', props.signUpRole);
        if (props.partnerIdentifier) {
          redirectParams.set('partnerIdentifier', props.partnerIdentifier);
        }
        window.location.assign(`${PARTNERSHIP_BFF_URL}/sign-up?${redirectParams.toString()}`);
      })
      .catch(() => {
        setCtaInputLoading(false);
      });
  };

  return (
    <React.Fragment>
      <Hero
        headerText="Sign up for your customized dashboard today"
        inputType="email"
        placeholder="Enter your work email"
        emailValue={email}
        isEmailInvalid={isEmailInvalid}
        onEmailChange={onEmailChange}
        onSubmit={handleSubmit}
        loading={ctaInputLoading}
      />
      <Footer />
    </React.Fragment>
  );
};

export default BuilderSalesPage;
